import React from 'react';
import { Skeleton } from 'antd';
import './style.scss';

const DashboardHeroSkeleton = () => {
  return (
    <>
      <section className="py-0 pt-0">
        <div className="container position-relative">
          <div className="row mb-3">
            <div className="col-12">
              <Skeleton paragraph={{ rows: 0 }} active />
              <Skeleton paragraph={{ rows: 0 }} active />
            </div>
          </div>
        </div>
      </section>

      <section className="card-grid pt-0">
        <div className="container">
          <div className="row g-2">
            <div className="col-md-6 row-gutter">
              <Skeleton.Image
                className="skeleton-image"
                style={{
                  width: '100%',
                  height: 'auto',
                  minHeight: 400,
                }}
              />
            </div>
            <div className="col-md-6 row-gutter">
              <div className="row g-2 row-gutter">
                <div className="col-12 row-gutter">
                  <Skeleton.Image
                    className="skeleton-image"
                    style={{
                      minHeight: 196,
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                 
                   
                </div>
                
                <div className="col-md-6 row-gutter">
                  <Skeleton.Image
                    className="skeleton-image"
                    style={{
                      minHeight: 196,
                      height: 'auto',
                    }}
                    />
                    </div>
                    <div className="col-md-6 row-gutter">
                  <Skeleton.Image
                    className="skeleton-image"
                    style={{
                      minHeight: 196,
                      height: 'auto',
                    }}
                    />
                    </div>
                
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export { DashboardHeroSkeleton };
